export default __webpack_public_path__ + "static/media/sponsor-suzuki.bab376fb.png";